import type { PlanName } from '../../../api/types';

// PARA-132 (AD-4, AC-16, AC-16a, AC-E9) — превентивное состояние кнопки.
// Чистая функция: план приходит из существующего useBillingStatus(), новых
// биллинговых запросов фича не заводит.

export type VoiceButtonState =
  /** Среда не умеет записывать — управляющего элемента нет вовсе (AC-E9). */
  | 'hidden'
  /** Тариф ниже Ultimate: кнопка нажимается и ведёт в биллинг (AC-16). */
  | 'gated'
  | 'available';

interface VoiceGatingContext {
  isSupported: boolean;
  /** undefined = план ещё не загружен либо GET /billing/me упал. */
  plan?: PlanName;
}

export function resolveVoiceButtonState({
  isSupported,
  plan,
}: VoiceGatingContext): VoiceButtonState {
  if (!isSupported) {
    return 'hidden';
  }
  // AC-16a: fail-open — неотвеченный вспомогательный запрос не отнимает функцию
  // у того, кто на неё имеет право; корректность страхует 403 от backend.
  if (plan === undefined) {
    return 'available';
  }
  return plan === 'ULTIMATE' ? 'available' : 'gated';
}
